export default {"src":"/_next/static/media/xvc.9de29848.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};